import React from 'react';

const items = [
  'Family-friendly',
  'Beginner-welcoming',
  'Eco-conscious',
  'Easy day-trip from Manila',
  'Catch & keep · Catch & release',
  'Open weekends · Holiday-ready',
];

export default function TrustStrip() {
  return (
    <section
      id="trust"
      data-testid="trust-strip"
      className="relative bg-pond text-offwhite py-5 overflow-hidden border-y border-moss/30"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {[...items, ...items, ...items].map((it, i) => (
          <div key={i} className="flex items-center px-8">
            <span className="overline">{it}</span>
            <span className="ml-8 w-1.5 h-1.5 rounded-full bg-sky/70" />
          </div>
        ))}
      </div>
    </section>
  );
}
